import React from 'react';
import {
  Box, TextField, Grid,
} from '@mui/material';
import { useSelector } from 'react-redux';
import SearchBox from '../../../components/templates/searchBox/SearchBox';
import DataMultiSelectList from '../../../components/atoms/DataMultiSelectList';
import { FormTitle, DatePicker } from '../../../components/atoms/Base';

export default function OpportunitySearchBox(props) {
  const {
    onSearch, onClear, onChange, condition, targetScreen, reSearch,
  } = props;
  const usetData = useSelector((state) => state.loginStore.userInfo);

  return (
    <SearchBox
      onSearch={onSearch}
      onClear={onClear}
      condition={condition}
      targetScreen={targetScreen}
      reSearch={reSearch}
    >
      <Grid container spacing={1}>
        <Grid item xs={12} md={6}>
          <FormTitle title="開催日" />
          <Box display="flex" alignItems="center">
            <Box>
              <DatePicker value={condition.heldDateStart} fullWidth name="heldDateStart" onChange={onChange} />
            </Box>
            <Box px={2}>～</Box>
            <Box>
              <DatePicker value={condition.heldDateEnd} fullWidth name="heldDateEnd" onChange={onChange} />
            </Box>
          </Box>
        </Grid>
        <Grid item xs={12} md={6}>
          <FormTitle title="支払方法" />
          <DataMultiSelectList
            name="payments"
            target="payment-methods"
            values={condition.payments}
            onChange={onChange}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <FormTitle title="提供方法" />
          <DataMultiSelectList
            name="serviceTypeCodes"
            target="codes"
            parameter={{ codeCategory: 'service_type' }}
            values={condition.serviceTypeCodes}
            onChange={onChange}
            exclusions={[3]}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <FormTitle title="プラン名" />
          <TextField autoComplete="off" value={condition.planName} fullWidth name="planName" onChange={onChange} />
        </Grid>
        <Grid item xs={12} md={6}>
          <FormTitle title="案件番号" />
          <TextField autoComplete="off" value={condition.opportunityNumber} fullWidth name="opportunityNumber" onChange={onChange} />
        </Grid>
        {!usetData.shopId && (
          <Grid item xs={12} md={6}>
            <FormTitle title="店舗" />
            <DataMultiSelectList
              name="shopIds"
              target="shops"
              values={condition.shopIds}
              onChange={onChange}
            />
          </Grid>
        )}
      </Grid>
    </SearchBox>
  );
}
